import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  state: {
    deployments: [],
    deploymentsLoading: false,
    deploymentUsersLoading: false,
    deploymentUsers: []
  },
  mutations: {
    setDeployments(state, deployments) {
      state.deployments = deployments;
    },
    setDeploymentsLoading(state, loading) {
      state.deploymentsLoading = loading;
    },
    setDeploymentUsersLoading(state, loading) {
      state.deploymentUsersLoading = loading;
    },
    setDeploymentUsers(state, users) {
      state.deploymentUsers = users;
    }
  },
  actions: {
    async loadDeployments({ commit }) {
      commit("setDeploymentsLoading", true);
      let deployments = await api.get("deployments");
      commit("setDeployments", deployments.data);
      commit("setDeploymentsLoading", false);
    },
    async newDeployment({ commit, dispatch }, payload) {
      delete payload.organizations_id;
      await api.post("deployments", payload);
      dispatch("loadDeployments");
      dispatch("loadOwnerships");
      dispatch("loadDevices");
    },
    async saveDeployment({ commit, dispatch }, payload) {
      await api.put("deployments", payload);
      dispatch("loadDeployments");
    },
    async endDeployment({ commit, dispatch }, payload) {
      await api.put("deployments/endDeployment", payload);
      dispatch("loadDeployments");
      dispatch("loadOwnerships");
      dispatch("loadDevices");
      dispatch("loadOrganizations");
    },
    async grantUserDeploymentAccess({ commit, dispatch }, payload) {
      await api.post("user/grantDeploymentAccess", payload);
      dispatch("loadDeployments");
      dispatch("loadUsers");
    },
    async loadDeploymentUsers({ commit }, deploymentID) {
      commit("setDeploymentUsersLoading", true);
      let users = await api.get("deployment/users", {
        params: {
          deploymentID: deploymentID
        }
      });
      commit("setDeploymentUsers", users.data);
      commit("setDeploymentUsersLoading", false);
    }
  },
  getters: {
    deploymentsLoading(state) {
      return state.deploymentsLoading;
    },
    deployments(state) {
      return state.deployments;
    },
    deploymentUsersLoading(state) {
      return state.deploymentUsersLoading;
    },
    deploymentUsers(state) {
      return state.deploymentUsers;
    }
  }
};
